import { Hub } from "@sentry/types";
import { IServiceProvider } from "angular";

export class SentryHubProvider implements IServiceProvider {
    $get: () => Hub = () => null;
}
